// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';

// Utils
import {
    getNotificationBoardTitle,
    getNotificationElementId,
} from '../../../../../../../common/notifications/notificationModelUtils';
import { getTitle } from '../../../../../../../common/elements/utils/elementPropertyUtils';
import { describeNotificationChanges } from './utils/notificationEntryElementChangeUtils';

// Components
import BaseNotificationEntry from './BaseNotificationEntry';
import UserNames from './UserNames';
import NotificationUserFigure from './NotificationFigureUser';
import Icon from '../../../../../../components/icons/Icon';

const BoardTitle = (props) => {
    const { group, element, notification, conjunction } = props;

    const groupId = get('id', group);
    const boardId = getNotificationElementId(notification);

    if (groupId === boardId) return null;

    const boardTitle = getTitle(element) || getNotificationBoardTitle(notification);

    if (!boardTitle) return <span> {conjunction} a board</span>;

    return (
        <span>
            {' '}
            {conjunction} <span className="board-title">{boardTitle}</span>
        </span>
    );
};

const NotificationEntryBoardTasksUpdate = (props) => {
    const { notification, actors } = props;

    const { sentence, conjunction } = describeNotificationChanges({ notification });

    return (
        <BaseNotificationEntry
            {...props}
            className="NotificationEntryBoardTasksUpdate"
            figure={<NotificationUserFigure {...props} icon={<Icon name="notification-task-update" />} />}
        >
            <div className="description">
                <UserNames users={actors} />
                {sentence || ' made to-do item changes '}
                <BoardTitle {...props} conjunction={conjunction} />
            </div>
        </BaseNotificationEntry>
    );
};

BoardTitle.propTypes = NotificationEntryBoardTasksUpdate.propTypes = {
    element: PropTypes.object,
    group: PropTypes.object,
    actors: PropTypes.array,
    notification: PropTypes.object,
    previousLastCheckedNotifications: PropTypes.number,
};

export default NotificationEntryBoardTasksUpdate;
